var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('Breadcrumb',{attrs:{"title":_vm.$t('spot-trade')}}),_c('div',{staticClass:"top-page-container remove-margins"},[_c('TopBlock',{staticClass:"mx-2"}),_c('div',{staticClass:"row main-block mx-2"},[_c('LeftBlock'),_c('MiddleBlock'),_c('RightBlock')],1),_c('BottomBlock')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }